import React, {useEffect, useState} from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useHistory } from "../../utils/router";
import Select from "react-select";
import { auth } from "../../utils/auth";
import { getLink, isCobrador, isVendedor, permisions } from "../../utils/helpers";
import { request } from "../../utils/request";
import useLocalStorage from "../../hooks/useLocalStorage";
import Modal from "./Modal";

const Sidebar = ({ toggleModal, movilAbierto = false, cerrarMovil = () => {} }) => {
    const location = useLocation();
    const history = useHistory();
    // const isGastos = location.pathname.indexOf("gastos") > -1;
    const isOperaciones = location.pathname.match(/(gi-)/)?.length > 0;
    const isEmpleados = location.pathname.match(/(empleados|tipos)/)?.length > 0;
    const isAusencias = location.pathname.match(/(ausencias|vacaciones)/)?.length > 0;
    const isCartas = location.pathname.indexOf("cartas") > -1;
    const isOrdenes = location.pathname.indexOf("ingresos") > -1;
    const isConsulta = location.pathname.indexOf("consultas") > -1;
    const isInventario = location.pathname.match(/(productos|inventario)/) > -1;
    const isAcademico = Boolean(location.pathname.match(/(academico)/));
    const isContabilidad = Boolean(location.pathname.match(/(cuentas-contables|entradas-de-diario|reportes-contables)/));
    const isSalud = Boolean(location.pathname.match(/(salud|visitas)/));

    const getActiveSubmenuFromPath = (path = location.pathname) => {
        if (path.match(/\/salud(\/|$)/)) return "salud";
        if (path.match(/\/(cuentas|cheques|cuentas-contables|entradas-de-diario|reportes-contables)(\/|$)/)) return "contabilidad";
        if (path.match(/\/(ingresos|facturas|facturas-recurrentes|cotizaciones|pedidos|despacho-facturas)(\/|$)/)) return "ingresos";
        if (path.match(/\/consultas(\/|$)/)) return "consultas";
        if (path.match(/\/gi-(grupos|servidores|prestamos)(\/|$)/)) return "operaciones";
        if (path.match(/\/(empleados|configuracion\/tipos|grupo-tipos-empleados)(\/|$)/)) return "empleados";
        if (path.match(/\/(ausencias|vacaciones)(\/|$)/)) return "ausencias";
        if (path.match(/\/cartas(\/|$)/)) return "cartas";
        if (path.match(/\/academico\/(recibos-cocurriculares|inscripcion-cocurriculares)(\/|$)/)) return "cocurriculares";
        if (path.match(/\/academico(\/|$)/)) return "academico";
        if (path.match(/\/(productos|inventario|compras|compras-recurrentes|gastos-internos)(\/|$)/)) return "inventario";
        return null;
    };

    const [activeSubmenu, setActiveSubmenu] = useState(() => getActiveSubmenuFromPath());
    const [isHoveringSidebar, setIsHoveringSidebar] = useState(false);
    const [fijado, setFijado] = useLocalStorage("sidebarFijado", false);

    // Fijado gana sobre el hover: si el usuario lo dejo abierto, entrar y salir con el
    // mouse no hace nada.
    const abierto = fijado || isHoveringSidebar;

    // .page-container y .header-desktop son hermanos del sidebar, no descendientes, asi
    // que el unico sitio desde donde se les puede empujar es el <body>.
    useEffect(() => {
        document.body.classList.toggle("sidebar-fijado", Boolean(fijado));

        return () => document.body.classList.remove("sidebar-fijado");
    }, [fijado]);

    useEffect(() => {
        setActiveSubmenu(getActiveSubmenuFromPath());
        cerrarMovil();
    }, [location.pathname]);

    const handleSubmenuClick = (submenuKey, event) => {
        event.preventDefault();
        setActiveSubmenu(prev => prev === submenuKey ? null : submenuKey);
    };

    // Al salir el mouse se vuelve al submenu de la pagina actual, no a null: antes el
    // menu se olvidaba de donde estabas en cuanto lo rozabas.
    const handleSidebarMouseLeave = () => {
        setIsHoveringSidebar(false);
        setActiveSubmenu(getActiveSubmenuFromPath());
    };

	const [rutas, setRutas] = useState([]);
	const [rutasSeleccionadas, setRutasSeleccionadas] = useState([]);
	const [showRutasModal, setShowRutasModal] = useState(false);

    const [almacenes, setAlmacenes] = useState([]);
    const [almacenesSeleccionados, setAlmacenesSeleccionados] = useState([]);
	const [showAlmacenesModal, setShowAlmacenesModal] = useState(false);

    const registerZonesToWork = () => {
        if(rutasSeleccionadas.length <= 0) return;

		localStorage.setItem("rutas", JSON.stringify(rutasSeleccionadas));

        setShowRutasModal(false);

        if (isVendedor()) {
            let url = "/ingresos/pedidos";
            if (isCobrador()) {
                url = "/consultas/cuentas-por-cobrar";
            }

            if (auth.can(permisions.dashboardVendedores)) {
                url = "/"
            }

            history.push(getLink(url));
        }
	};

    const registerAlmacenesToWork = () => {
        if(almacenesSeleccionados.length <= 0) return;

		localStorage.setItem("almacenes", JSON.stringify(almacenesSeleccionados));

        setShowAlmacenesModal(false);

        if (!isOrdenes) {
            history.push(getLink(isCobrador() ? "/consultas/cuentas-por-cobrar" : "/ingresos/pedidos"));
        }
	};

    const getRutasForDropdown = () => {
        const url = auth.getUser().rol === 'vendedor-cliente' ? 'rutas-clientes' : 'rutas?limit=100';
		request(url).then((res) => {
			setRutas([
				...res.data.map((ruta) => ({
					value: ruta.id,
					label: `${ruta.nombre} ${ruta.descripcion}`,
				})),
			]);
		});
	};

    const getAlmacenesForDropdown = () => {
        const url = 'almacenes';
		request(url).then((res) => {
			setAlmacenes([
				...res.data.map((alamacen) => ({
					value: alamacen.id,
					label: alamacen.nombre,
				})),
			]);
		});
	};

    useEffect(()  => {
        /*if (isVendedor() && !localStorage.getItem("rutas")) {
            getRutasForDropdown();
            setShowRutasModal(true);
		}*/

        if (auth.getUser().rol === 'vendedor-cliente' && !localStorage.getItem("almacenes")) {
            getAlmacenesForDropdown();
            setShowAlmacenesModal(true);
        }
    }, [location.pathname]);

    const user = auth.getUser();
    const sucursalActual = user.sucursales.filter(s => s.id === user.sucursalActual)[0];

    return (
        <>
            <div
                className={`sidebar-overlay ${movilAbierto ? "visible" : ""}`}
                onClick={cerrarMovil}
            />
            <aside
                id="sidebar"
                className={`menu-sidebar ${abierto ? "abierto" : ""} ${movilAbierto ? "movil-abierto" : ""}`}
                onClick={() => toggleModal("showReportes", false)}
                onMouseEnter={() => setIsHoveringSidebar(true)}
                onMouseLeave={handleSidebarMouseLeave}>
                <div className='menu-sidebar__content js-scrollbar1'>
                    <nav className='navbar-sidebar'>
                        <ul className='list-unstyled navbar__list'>
                            {(auth.can(permisions.verDashboard) || auth.can(permisions.dashboardVendedores)) && (
                                <>
                                    <li>
                                        {/* `to` sin barra final: el `end` de v7 compara
                                            pathnames literalmente y la ruta de inicio
                                            es '/:sucursal'. */}
                                        <NavLink
                                            className='js-arrow'
                                            to={getLink("")}
                                            end>
                                            <i className='zmdi zmdi-home' />
                                            <span className="menu-name">Inicio</span>
                                        </NavLink>
                                    </li>
                                </>
                            )}

                            {(auth.can(permisions.verContabilidad) ||
                              auth.can(permisions.verContratos) ||
                              auth.can(permisions.verCompras) ||
                              auth.can(permisions.verCompras) ||
                              auth.can(permisions.verOrdenesCompra) ||
                              auth.can(permisions.verIngresos) ||
                              auth.can(permisions.verConsultas)
                            ) && <>
                                <li className="sidebar-header"><span>Finanzas y Administración</span></li>

                                {auth.can(permisions.verContabilidad) && (
                                    <li
                                        className={`has-sub ${activeSubmenu === "contabilidad" && abierto ? "active" : ""}`}>
                                        <a
                                            href='#sub'
                                            className='parent-label'
                                            onClick={(e) => handleSubmenuClick("contabilidad", e)}>
                                            <i className="zmdi zmdi-balance"></i>
                                            <span className="menu-name">Contabilidad</span>
                                        </a>
                                        <ul className='sub-menu'>
                                            {auth.can(permisions.verCuentas) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/cuentas")}>
                                                        <span className="menu-name">Bancos</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {auth.can(permisions.verCheque) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/cheques")}>
                                                        <span className="menu-name">Cheques</span>
                                                    </NavLink>
                                                </li>
                                             )}
                                            {auth.can(permisions.verCuentaContable) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/cuentas-contables")}>
                                                        <span className="menu-name">Cuentas Contables</span>
                                                    </NavLink>
                                                </li>
                                             )}
                                            {auth.can(permisions.verEntradasDiarios) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/entradas-de-diario")}>
                                                        <span className="menu-name">Entradas de Diario</span>
                                                    </NavLink>
                                                </li>
                                             )}
                                            {auth.can(permisions.verReporteContables) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/reportes-contables")}>
                                                        <span className="menu-name">Reportes Contables</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                        </ul>
                                    </li>
                                )}

                                {auth.can(permisions.verContratos) && (
                                    <li>
                                        <NavLink
                                            href='#sub'
                                            className='js-arrow'
                                            to={getLink("/contratos")}

                                        >
                                            <i className="zmdi zmdi-file-text"/>
                                            <span className="menu-name">Contratos</span>
                                        </NavLink>
                                    </li>
                                )}

                                {auth.can(permisions.verIngresos) && (
                                    <li
                                        className={`has-sub ${activeSubmenu === "ingresos" && abierto ? "active" : ""}`}>
                                        <a
                                            href='#sub'
                                            className='parent-label'
                                            onClick={(e) => handleSubmenuClick("ingresos", e)}>
                                            <i className="zmdi zmdi-download"></i>
                                            <span className="menu-name">Ingresos</span>
                                        </a>
                                        <ul className='sub-menu'>
                                            {auth.can(permisions.verCotizaciones) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/ingresos/cotizaciones")}>
                                                        <span className="menu-name">Cotizaciones</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {auth.can(permisions.verPedidos) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/ingresos/pedidos")}>
                                                        <span className="menu-name">Pedidos</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {auth.can(permisions.verFacturas) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/ingresos/facturas")}>
                                                        <span className="menu-name">Facturas</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {auth.can(permisions.verFacturasRecurrentes) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/ingresos/facturas-recurrentes")}>
                                                        <span className="menu-name">Facturas Recurrentes</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {auth.can(permisions.verNotasCredito) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/ingresos/notas-credito")}>
                                                        <span className="menu-name">Notas de crédito</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {auth.can(permisions.verNotasDebito) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/ingresos/notas-debito")}>
                                                        <span className="menu-name">Notas de débito</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {auth.can(permisions.verDespachoFacturas) && (<li>
                                                <NavLink
                                                    to={getLink("/ingresos/despacho-facturas")}>
                                                    <span className="menu-name">Despacho de Facturas</span>
                                                </NavLink>
                                            </li>)}
                                            {auth.can(permisions.verCuadreCaja) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/ingresos/cuadre-caja")}>
                                                        <span className="menu-name">Cuadre de Caja</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                        </ul>
                                    </li>
                                )}

                                {(auth.can(permisions.verCompras) || auth.can(permisions.verComprasRecurrentes) || auth.can(permisions.verOrdenesCompra)) && <li className={`has-sub ${activeSubmenu === "egresos" && abierto ? "active" : ""}`}>
                                    <a
                                        href='#sub'
                                        className='parent-label'
                                        onClick={(e) => handleSubmenuClick("egresos", e)}>
                                        <i className="zmdi zmdi-upload"></i>
                                        <span className="menu-name">Egresos</span>
                                    </a>

                                    <ul className='sub-menu'>
                                        {auth.can(permisions.verCompras) && (
                                            <li>
                                                <NavLink to={getLink("/compras")}>
                                                    <span className="menu-name">Compras</span>
                                                </NavLink>
                                            </li>
                                        )}
                                        {auth.can(permisions.verComprasRecurrentes) && (
                                            <li>
                                                <NavLink to={getLink("/compras-recurrentes")}>
                                                    <span className="menu-name">Compras Recurrentes</span>
                                                </NavLink>
                                            </li>
                                        )}
                                        {auth.can(permisions.verOrdenesCompra) && (
                                            <li>
                                                <NavLink to={getLink("/ordenes-compra")}>
                                                    <span className="menu-name">Ordenes de Compra</span>
                                                </NavLink>
                                            </li>
                                        )}
                                        {auth.can(permisions.verNotasCredito) && (
                                            <li>
                                                <NavLink
                                                    to={getLink("/egresos/notas-credito")}>
                                                    <span className="menu-name">Notas de crédito</span>
                                                </NavLink>
                                            </li>
                                        )}
                                    </ul>
                                </li>}

                                {auth.can(permisions.verConsultas) && (
                                    <li
                                        className={`has-sub ${activeSubmenu === "consultas" && abierto ? "active" : ""}`}>
                                        <a
                                            href='#sub'
                                            className='parent-label'
                                            onClick={(e) => handleSubmenuClick("consultas", e)}>
                                            <i className="zmdi zmdi-search"></i>
                                            <span className="menu-name">Consultas</span>
                                        </a>
                                        <ul className='sub-menu'>
                                            {auth.can(permisions.verCuentasPorCobrar) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/consultas/cuentas-por-cobrar")}>
                                                        <span className="menu-name">Cuentas por cobrar</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {auth.can(permisions.verCuentasPorPagar) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/consultas/cuentas-por-pagar")}>
                                                        <span className="menu-name">Cuentas por pagar</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {auth.can(permisions.verRecibosIngreso) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/consultas/recibos")}>
                                                        <span className="menu-name">Recibos</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                        </ul>
                                    </li>
                                )}

                                {auth.can(permisions.verReportes) && (
                                    <li>
                                        <NavLink
                                            to={getLink("/reportes")}>
                                            <i className="zmdi zmdi-chart"/>

                                            <span className="menu-name">Reportes</span>
                                        </NavLink>
                                    </li>
                                )}

                            </>}

                            {(auth.can(permisions.salud) ||
                              auth.can(permisions.verEmpleados) ||
                              auth.can(permisions.verAusencias) ||
                              auth.can(permisions.verCartas) ||
                              auth.can(permisions.verNomina) ||
                              auth.can(permisions.verDescuentos) ||
                              auth.can(permisions.verIncentivos) ||
                              auth.can(permisions.verSolicitudes)
                            ) && <>
                                <li className="sidebar-header"><span>Recursos Humanos</span></li>

                                {auth.can(permisions.salud) && (
                                    <li className={`has-sub ${activeSubmenu === "salud" && abierto ? "active" : ""}`}>
                                        <a href='#sub' className='parent-label' onClick={(e) => handleSubmenuClick("salud", e)}>
                                            <i className="zmdi zmdi-hospital"></i>
                                            <span className="menu-name">Salud</span>
                                        </a>

                                        <ul className='sub-menu'>
                                            <NavLink
                                                to={getLink("/salud")}>
                                                <span className="menu-name">Dashboard</span>
                                            </NavLink>
                                            {auth.can(permisions.visitaSalud) && <li>
                                                <NavLink
                                                    to={getLink("/salud/visitas")}>
                                                    <span className="menu-name">Visitas</span>
                                                </NavLink>
                                            </li>}
                                            {auth.can(permisions.pacientes) && <li>
                                                <NavLink
                                                    to={getLink("/salud/pacientes")}>
                                                    <span className="menu-name">Pacientes</span>
                                                </NavLink>
                                            </li>}
                                            {auth.can(permisions.inventarioSalud) && <li>
                                                <NavLink
                                                    to={getLink("/salud/inventario")}>
                                                    <span className="menu-name">Insumos</span>
                                                </NavLink>
                                            </li>}
                                        </ul>
                                    </li>
                                )}

                                {auth.can(permisions.verEmpleados) && (
                                    <li
                                        className={`has-sub ${activeSubmenu === "empleados" && abierto ? "active" : ""}`}>
                                        <a
                                            href='#sub'
                                            className='parent-label'
                                            onClick={(e) => handleSubmenuClick("empleados", e)}>
                                            <i className='zmdi zmdi-accounts' />
                                            <span className="menu-name">Empleados</span>
                                        </a>
                                        <ul className='sub-menu'>
                                            <li>
                                                <NavLink to={getLink("/empleados")}>
                                                    <span className="menu-name">Listado</span>
                                                </NavLink>
                                            </li>
                                            {auth.can(permisions.verTipos) &&<li>
                                                <NavLink to={getLink("/configuracion/tipos")}>
                                                    <span className="menu-name">Tipos Empleados</span>
                                                </NavLink>
                                            </li>}
                                            {auth.can(permisions.verGrupoTiposEmpleados) &&<li>
                                                <NavLink
                                                    to={getLink("/grupo-tipos-empleados")}>
                                                    <span className="menu-name">Grupos Tipos</span>
                                                </NavLink>
                                            </li>}
                                        </ul>
                                    </li>
                                )}

                                {auth.can(permisions.verAusencias) && (
                                    <li
                                        className={`has-sub ${activeSubmenu === "ausencias" && abierto ? "active" : ""}`}>
                                        <a
                                            href='#sub'
                                            className='parent-label'
                                            onClick={(e) => handleSubmenuClick("ausencias", e)}>
                                            <i className='zmdi zmdi-calendar-close' />
                                            <span className="menu-name">Ausencias</span>
                                        </a>
                                        <ul className='sub-menu'>
                                            <li>
                                                <NavLink
                                                    to={getLink("/ausencias")}>
                                                    <span className="menu-name">Generales</span>
                                                </NavLink>
                                            </li>

                                            <li>
                                                <NavLink to={getLink("/vacaciones")}>
                                                    <span className="menu-name">Vacaciones</span>
                                                </NavLink>
                                            </li>

                                                <li>
                                                    <NavLink to={getLink("/configuracion/tipo-ausencias")}>
                                                        <span className="menu-name">Tipos Ausencias</span>
                                                    </NavLink>
                                                </li>
                                        </ul>
                                    </li>
                                )}

                                {(auth.can(permisions.verCartas)  || auth.can(permisions.verPlantillas) ) && (
                                    <li className={`has-sub ${activeSubmenu === "cartas" && abierto ? "active" : ""}`}>
                                        <a
                                            href='#sub'
                                            className='parent-label'
                                            onClick={(e) => handleSubmenuClick("cartas", e)}>
                                            <i className='zmdi zmdi-email' />
                                            <span className="menu-name">Cartas</span>
                                        </a>

                                        <ul className='sub-menu'>
                                            <li>
                                                <NavLink to={getLink("/cartas/letters")}>
                                                    <span className="menu-name">Listado</span>
                                                </NavLink>

                                                {auth.can(permisions.verPlantillas) && (
                                                    <NavLink to={getLink("/cartas/plantillas")}>
                                                        <span className="menu-name">Plantillas</span>
                                                    </NavLink>
                                                )}
                                            </li>
                                        </ul>
                                    </li>
                                )}

                                {(auth.can(permisions.verNomina) || auth.can(permisions.verDescuentos) || auth.can(permisions.verIncentivos)) && <li className={`has-sub ${activeSubmenu === "nomina" && abierto ? "active" : ""}`}>
                                    <a
                                        href='#sub'
                                        className='parent-label'
                                        onClick={(e) => handleSubmenuClick("nomina", e)}>
                                        <i className='zmdi zmdi-money' />
                                        <span className="menu-name">Nómina</span>
                                    </a>

                                    <ul className='sub-menu'>
                                        {auth.can(permisions.verNomina) && (
                                            <li>
                                                <NavLink to={getLink("/nomina")}>
                                                    <span className="menu-name">Historial</span>
                                                </NavLink>
                                            </li>
                                        )}

                                        {auth.can(permisions.verDescuentos) && (
                                            <li>
                                                <NavLink to={getLink("/descuentos")}>
                                                    <span className="menu-name">Descuentos</span>
                                                </NavLink>
                                            </li>
                                        )}

                                        {auth.can(permisions.verIncentivos) && (
                                            <li>
                                                <NavLink to={getLink("/incentivos")}>
                                                    <span className="menu-name">Incentivos</span>
                                                </NavLink>
                                            </li>
                                        )}
                                    </ul>
                                </li>}

                                {auth.can(permisions.verSolicitudes) && (
                                    <li>
                                        <NavLink to={getLink("/solicitudes")}>
                                            <i className='zmdi zmdi-assignment' />
                                            <span className="menu-name">Tareas</span>
                                        </NavLink>
                                    </li>
                                )}

                            </>}

                            {(auth.can(permisions.verVehiculos) ||
                              auth.can(permisions.verServicios) ||
                              auth.can(permisions.verInventario)
                            ) && <>
                                <li className="sidebar-header"><span>Operaciones</span></li>

                                {(auth.can(permisions.verVehiculos) || auth.can(permisions.verServicios)) && <li className={`has-sub ${activeSubmenu === "vehiculos" && abierto ? "active" : ""}`}>
                                    <a
                                        href='#sub'
                                        className='parent-label'
                                        onClick={(e) => handleSubmenuClick("vehiculos", e)}>
                                        <i className="zmdi zmdi-truck"></i>
                                        <span className="menu-name">Vehículos</span>
                                    </a>

                                    <ul className='sub-menu'>
                                        {auth.can(permisions.verVehiculos) && (
                                            <li>
                                                <NavLink to={getLink("/vehiculos")}>
                                                    <span className="menu-name">Listado</span>
                                                </NavLink>
                                            </li>
                                        )}

                                        <li>
                                            <NavLink to={getLink("/configuracion/categorias")}>
                                                <span className="menu-name">Categorías</span>
                                            </NavLink>
                                        </li>

                                        {auth.can(permisions.verServicios) && (
                                            <li>
                                                <NavLink to={getLink("/servicios")}>
                                                    <span className="menu-name">Servicios</span>
                                                </NavLink>
                                            </li>
                                        )}
                                    </ul>
                                </li>}

                                {auth.can(permisions.verInventario) && (
                                    <li
                                        className={`has-sub ${activeSubmenu === "inventario" && abierto ? "active" : ""}`}>
                                        <a
                                            href='#sub'
                                            className='parent-label'
                                            onClick={(e) => handleSubmenuClick("inventario", e)}>
                                            <i className='zmdi zmdi-store' />
                                            <span className="menu-name">Inventario</span>
                                        </a>
                                        <ul className='sub-menu'>
                                            {auth.can(permisions.verProductos) && (<li>
                                                <NavLink to={getLink("/productos")}>
                                                    <span className="menu-name">Productos</span>
                                                </NavLink>
                                            </li>)}
                                            {auth.can(permisions.verCategorias) && (<li>
                                                <NavLink to={getLink("/configuracion/grupos")}>
                                                    <span className="menu-name">Categorías</span>
                                                </NavLink>
                                            </li>)}
                                            {auth.can(permisions.verAlmacenes) && (<li>
                                                <NavLink to={getLink("/configuracion/almacenes")} className="d-block">
                                                    <span className="menu-name">Almacenes</span>
                                                </NavLink>
                                            </li>)}
                                            {auth.can(permisions.verUbicaciones) && (<li>
                                                <NavLink to={getLink("/configuracion/ubicaciones")} className="d-block">
                                                    <span className="menu-name">Ubicaciones</span>
                                                </NavLink>
                                            </li>)}
                                            {auth.can(permisions.verGastos) && (
                                                <li>
                                                    <NavLink to={getLink("/gastos-internos")}>
                                                        <span className="menu-name">Despacho interno</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {auth.can(permisions.verActivoFijo) && (<li>
                                                <NavLink to={getLink("/inventario")}>
                                                    <span className="menu-name">Activos Fijos</span>
                                                </NavLink>
                                            </li>)}
                                        </ul>
                                    </li>
                                )}
                            </>}

                            {(auth.can(permisions.verContactos)) && <>
                                <li className="sidebar-header"><span>Relaciones</span></li>

                                {auth.can(permisions.verContactos) && (
                                    <li>
                                        <NavLink to={getLink("/contactos")}>
                                            <i className='zmdi zmdi-accounts-list' />
                                            <span className="menu-name">Contactos</span>
                                        </NavLink>
                                    </li>
                                )}

                                {/* <li className='separator' /> */}
                            </>}














                            {/* {sucursalActual.tipo === 'educativa' && auth.can(permisions.verAcademico) && (
                                <>
                                    <li
                                        className={`has-sub ${activeSubmenu === "academico" && abierto ? "active" : ""}`}>
                                        <a
                                            href='#sub'
                                            className='parent-label'
                                            onClick={(e) => handleSubmenuClick("academico", e)}>
                                            <i className="fas fa-graduation-cap"></i>
                                            <span className="menu-name">Académico</span>
                                        </a>
                                        <ul className='sub-menu'>
                                            {auth.can(permisions.verEvaluaciones) && (
                                            <li>
                                                <NavLink
                                                    to={getLink("/academico/evaluaciones")}>
                                                    <span className="menu-name">Evaluaciones</span>
                                                </NavLink>
                                            </li>
                                            )}
                                            {auth.can(permisions.verEstudiantes) && (
                                            <li>
                                                <NavLink
                                                    to={getLink("/academico/estudiantes")}>
                                                    <span className="menu-name">Estudiantes</span>
                                                </NavLink>
                                            </li>
                                            )}
                                            {auth.can(permisions.verInscripcion) && (
                                            <li>
                                                <NavLink
                                                    to={getLink("/academico/inscripcion")}>
                                                    <span className="menu-name">Inscripción</span>
                                                </NavLink>
                                            </li>
                                            )}
                                            {auth.can(permisions.verPadrestutores) && (
                                            <li>
                                                <NavLink
                                                    to={getLink("/academico/padres-tutores")}>
                                                    <span className="menu-name">Padres/Tutores</span>
                                                </NavLink>
                                            </li>
                                            )}
                                            {auth.can(permisions.verFacturacionAcademica) && (
                                                <>
                                                    <li>
                                                        <NavLink
                                                            to={getLink("/academico/recibos")}>
                                                            <span className="menu-name">Cobros Académicos</span>
                                                        </NavLink>
                                                    </li>
                                                </>
                                            )}
                                        </ul>
                                    </li>

                                    <li className='separator' />
                                </>
                            )} */}

                            {/* {sucursalActual.tipo === 'educativa' && auth.can(permisions.verCocurriculares) && (
                                <>
                                    <li
                                        className={`has-sub ${activeSubmenu === "cocurriculares" && abierto ? "active" : ""}`}>
                                        <a
                                            href='#sub'
                                            className='parent-label'
                                            onClick={(e) => handleSubmenuClick("cocurriculares", e)}>
                                            <i className="zmdi zmdi-palette" style={{fontSize: '1.4rem'}}></i>
                                            <span className="menu-name">Cocurriculares</span>
                                        </a>
                                        <ul className='sub-menu'>
                                            {auth.can(permisions.verCobros) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/academico/recibos-cocurriculares")}>
                                                        <span className="menu-name">Cobros</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {auth.can(permisions.verInscripcion) && (
                                                <li>
                                                    <NavLink
                                                        to={getLink("/academico/inscripcion-cocurriculares")}>
                                                        <span className="menu-name">Inscripción</span>
                                                    </NavLink>
                                                </li>
                                            )}
                                        </ul>
                                    </li>

                                    <li className='separator' />
                                </>
                            )} */}

                            {/* {auth.can(permisions.verProgramacion) && (
                                <li>
                                    <NavLink
                                        className='js-arrow'
                                        to={getLink("/programaciones")}>
                                        <i className='fas fa-calendar-alt' />
                                        <span className="menu-name">Programación</span>
                                    </NavLink>
                                </li>
                            )} */}

                            {/* {auth.can(permisions.verGiGrupos) && (
                                <li
                                    className={`has-sub ${activeSubmenu === "operaciones" && abierto ? "active" : ""}`}>
                                    <a
                                        href='#sub'
                                        className='parent-label'
                                        onClick={(e) => handleSubmenuClick("operaciones", e)}>
                                        <i className='fas fa-cogs' />
                                        <span className="menu-name">Operaciones</span>
                                    </a>
                                    <ul className='sub-menu'>
                                        <li>
                                            <NavLink
                                                to={getLink("/gi-grupos")}>
                                                <span className="menu-name">Grupos</span>
                                            </NavLink>
                                        </li>
                                        {auth.can(permisions.verGiServidores) && (<li>
                                            <NavLink
                                                to={getLink("/gi-servidores")}>
                                                <span className="menu-name">Servidores</span>
                                            </NavLink>
                                        </li>)}
                                        {auth.can(permisions.verGiPrestamos) && (<li>
                                            <NavLink
                                                to={getLink("/gi-prestamos")}>
                                                <span className="menu-name">Préstamos</span>
                                            </NavLink>
                                        </li>)}
                                    </ul>
                                </li>
                            )} */}

                            {/* {auth.can(permisions.verReclamaciones) && (
                                <li>
                                    <NavLink to={getLink("/reclamaciones")}>
                                        <i className='fa fa-exclamation-circle' />
                                        <span className="menu-name">Reclamaciones</span>
                                    </NavLink>
                                </li>
                            )} */}
                        </ul>
                    </nav>
                </div>
            </aside>

            {/* Pestaña pegada por fuera del borde derecho del sidebar. Va aquí, fuera del
                <aside>, porque dentro la recortaría su overflow:hidden. Sigue al estado
                fijado, no al hover: si siguiera al hover, acercarle el cursor lo empujaría
                fuera del puntero y entraría en bucle. */}
            <button
                type='button'
                className='sidebar-toggle'
                title={fijado ? "Colapsar el menú" : "Expandir el menú"}
                aria-label={fijado ? "Colapsar el menú" : "Expandir el menú"}
                aria-expanded={Boolean(fijado)}
                aria-controls='sidebar'
                onClick={() => setFijado(estado => !estado)}>
                <i className={fijado ? "zmdi zmdi-chevron-left" : "zmdi zmdi-chevron-right"} />
            </button>

            <Modal
                show={showAlmacenesModal}
                size="sm"
                callback={registerAlmacenesToWork}
                toggle={() => setShowAlmacenesModal(state => !state)}
                showCancelBtn={false}
                title="Seleccione Almacen(es)"
                classes={{content: "zone-selector"}}
            >
                <div className="form-group">
                    <label>Seleccione almacenes a Trabajar</label>
                    <Select
                        id="inputVendedor"
                        options={almacenes}
                        isMulti
                        onChange={(e) => setAlmacenesSeleccionados(e)}
                        menuPortalTarget={document.body}
                        closeMenuOnSelect={false}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 200005 }),
                        }}
                    />
                </div>
            </Modal>
            <Modal
                show={showRutasModal}
                size="sm"
                callback={registerZonesToWork}
                toggle={() => setShowRutasModal(state => !state)}
                showCancelBtn={false}
                title="Seleccione Zona(s)"
                classes={{content: "zone-selector"}}
            >
                <div className="form-group">
                    <label>Seleccione zonas a Trabajar</label>
                    <Select
                        id="inputVendedor"
                        options={rutas}
                        isMulti
                        menuPosition="fixed"
                        onChange={(e) => setRutasSeleccionadas(e)}
                        menuPortalTarget={document.body}
                        closeMenuOnSelect={false}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 200005 }),
                        }}
                    />
                </div>
            </Modal>
        </>

    );
};

export default Sidebar;
